export default __webpack_public_path__ + "static/media/GustavSwordParticle.ec9fce04.png";